import { faEdit } from '~components/icon';
import { Column } from '~components/table-view';
import { linkCellRender } from '~components/table-view/columnRenderers';

const columnsFactory = (togglePricePlanModal: (id: string) => void) => {
  const columns: Column[] = [
    {
      id: 'name',
      header: 'Plan Name',
      type: 'text',
      renderReadOnly: linkCellRender((row) => togglePricePlanModal(row.id), faEdit),
    },
    {
      id: 'start_date',
      header: 'Start Date',
      type: 'date',
    },
    {
      id: 'end_date',
      header: 'End Date',
      type: 'date',
    },
    {
      id: 'revision_id',
      header: 'Revision',
      type: 'text',
      deriveValue: (row) => `Version ${row.latest_revision}`,
    },
  ];

  return columns;
};

export default columnsFactory;
